const noop = Function.prototype;

// we only want to run this client-side
let clientLogger = {
    captureBreadcrumb: noop,
    captureException: noop,
    captureMessage: noop
};
/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Sentry) {
    if (process.env.NODE_ENV === 'development') {
        clientLogger.captureBreadcrumb = (...args) =>
            console.log('%cBreadcrumb: ', 'font-weight: bold', ...args); // eslint-disable-line no-console
        clientLogger.captureException = console.error; // eslint-disable-line no-console
        clientLogger.captureMessage = console.log; // eslint-disable-line no-console
    } else {
        clientLogger = window.Sentry;
    }
}

export const LOG_ERROR = {
    level: 'error'
};

export const LOG_WARNING = {
    level: 'warning'
};

export default clientLogger;
